module.exports = __webpack_public_path__ + "static/assets/81dc21a52d314d1c74b6f74ddc4e8e41.png";